import React from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import PinSetupForm from '../../components/forms/PinSetupForm/PinSetupForm';

const SetupPin = () => {

  const { uid } = useParams();
  // console.log(`user id retrieved`, uid);

  return (
    <AuthLayout pageName="user-setup">
      <PinSetupForm userId={uid} />
    </AuthLayout>
  );
};

export default SetupPin;
